interface NoItemImageFoundProps {
  classname?: string;
  children: React.ReactNode;
}

export const FallbackItemImage = ({
  classname,
  children,
}: NoItemImageFoundProps) => {
  return <div className={classname}>{children}</div>;
};
